<template>
  <div class="aui-flexView" style="z-index: 6">
    <router-view></router-view>
  </div>
</template>

<script>
import scrollService from '../../../services/scrollService'

export default {
  name: 'book-index',
  data () {
    return {
      topTitle: '',
      topTitle2: ''
    }
  },
  methods: {},
  components: {
  },
  mounted () {
    scrollService.scrollToTop()
  }
}
</script>

<style scoped>
</style>
